import { PaySafeCardDepositActionResult, PaymentMethods } from "@models/C_Transactions";
import { PaymentsCommonErrorCodes } from "@models/MasterData";
import { ErrorService } from "@providers/ErrorService";
import { TrackingService } from "@providers/TrackingService";
import { UserService } from "@providers/UserService";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
/* eslint-disable */
import { IFramePaymentMethodBehaviourResult, PaymentMethodBehaviour, SkipAmountResult } from "./PaymentMethodBase";

export class Praxis_VISAMethodBehaviour extends PaymentMethodBehaviour {
  name = "VISA";
  image = "Visa_epg";
  track = "AccessToEPG";
  isBank = false;
  minDepositAmount = 10;
  maxDepositAmount = 100000;
  amountButtons: number[] = [10, 20, 40, 50];
  amount = 20;

  constructor(userService: UserService, errorService: ErrorService, trackingService: TrackingService) {
    super(false, userService, errorService, trackingService);
  }

  skipAmountInput(): Observable<SkipAmountResult> {
    return new Observable<SkipAmountResult>();
  }

  paymentMetodExecution(): Observable<IFramePaymentMethodBehaviourResult> {
    return this.userService.validateDepositPraxis(this.amount, PaymentMethods.Visa).pipe(
      map((obj) => {
        return this.map(obj);
      }),
      catchError((error, caught) => {
        this.trackCatchError("VISA_PRAXIS", { err: error, caught: caught });
        return of(<IFramePaymentMethodBehaviourResult>this.getGenericErrorResult());
      }),
    );
  }

  private map(input: PaySafeCardDepositActionResult): IFramePaymentMethodBehaviourResult {
    const result = new IFramePaymentMethodBehaviourResult();
    if (input.success) {
      result.success = true;
      result.iframeType = "praxis";
      result.iframeArgs = { type: "praxis", url: input.url };
    } else {
      result.success = false;
      result.erroMessage = this.errorService.searchErrorCodeWithParams(
        "error" + input.errCode,
        input.errorParameters,
      );
      result.errorcode = input.errCode;
      result.sendToDocumentVerificationPage =
        input.errCode === PaymentsCommonErrorCodes.MUST_COMPLETE_DOC_VERIFICATION ||
        input.errCode === PaymentsCommonErrorCodes.LIMIT_NOT_VERIFIED_SURPASSED;
      result.sendToProfesion = input.errCode === PaymentsCommonErrorCodes.MUST_FILL_PROFESSION_ON_VERIFICATION;
    }
    return result;
  }
}
